import type { HttpError } from "@refinedev/core";
import axios from "axios";
import * as Sentry from "@sentry/react";

const AUTH_PATHS = ['/auth/send-otp', '/auth/login', '/auth/resend-otp'];

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
});

// Add a request interceptor to dynamically set the token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    if (config.data) {
        config.data = { data: config.data };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const isAuthPath = error.config?.url && AUTH_PATHS.some(path => error.config.url.includes(path));
    
    // not throwing error for auth paths to allow user to reenter and otp if wrong and not redirect to login
    if (error.response?.status === 401 && !isAuthPath) {
      localStorage.removeItem("token");
      window.location.href = `/login?error=${encodeURIComponent("Your session has expired. Please login again.")}`;
      return Promise.reject(error);
    }

    const customError: HttpError = {
      ...error,
      message: error.response?.data?.message,
      statusCode: error.response?.status,
    };

    Sentry.captureMessage(customError.response?.data.error);

    return Promise.reject(customError);
  },
);

export { axiosInstance };